const CasinoIcon = () => (
  <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
    <rect x="2" y="2" width="16" height="16" rx="3" fill="none" stroke="currentColor" strokeWidth="2"/>
    <circle cx="6.5" cy="6.5" r="1.25"/>
    <circle cx="13.5" cy="6.5" r="1.25"/>
    <circle cx="6.5" cy="13.5" r="1.25"/>
    <circle cx="13.5" cy="13.5" r="1.25"/>
    <circle cx="10" cy="10" r="1.25"/>
  </svg>
)

const FantasyDungeonLeagueIcon = () => (
  <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
    <circle cx="12" cy="6" r="2"></circle>
    <path d="M1 18a1 1 0 0 1-.707-1.707l7-7a1 1 0 0 1 1.414 1.414l-7 7A1 1 0 0 1 1 18zM15 4a1 1 0 0 1-.707-1.707l2-2a1 1 0 0 1 1.414 1.414l-2 2A1 1 0 0 1 15 4zm-3-1a1 1 0 0 1-1-1V1a1 1 0 0 1 2 0v1a1 1 0 0 1-1 1zm0 9a1 1 0 0 1-1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1-1 1z"></path>
    <path d="M12 3a1 1 0 0 1-1-1V1a1 1 0 0 1 2 0v1a1 1 0 0 1-1 1zm0 9a1 1 0 0 1-1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1-1 1zM8 7H7a1 1 0 1 1 0-2h1a1 1 0 1 1 0 2zm9 0h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2zM9 4a1 1 0 0 1-.707-.293l-2-2A1 1 0 0 1 7.707.293l2 2A1 1 0 0 1 9 4zm8 8a1 1 0 0 1-.707-.293l-2-2a1 1 0 0 1 1.414-1.414l2 2A1 1 0 0 1 17 12z"></path>
  </svg>
)

// Stylized as a chain of islands sweeping through a pronounced arc northeast-to-southwest,
// echoing the bowed shape of the Japanese archipelago rather than any single national emblem.
const RiskIcon = () => (
  <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
    <ellipse cx="15" cy="3" rx="1.6" ry="1" transform="rotate(75 15 3)" />
    <ellipse cx="15.4" cy="8.6" rx="2.4" ry="1.3" transform="rotate(95 15.4 8.6)" />
    <ellipse cx="14.1" cy="12.9" rx="2.8" ry="1.5" transform="rotate(125 14.1 12.9)" />
    <ellipse cx="10.4" cy="15.6" rx="2.2" ry="1.2" transform="rotate(150 10.4 15.6)" />
    <ellipse cx="5" cy="17" rx="1.3" ry="0.8" transform="rotate(165 5 17)" />
  </svg>
)

export const GAMES = [
  { href: '/casino', title: 'Casino', Icon: CasinoIcon },
  { href: '/fantasy-dungeon-league', title: 'Fantasy Dungeon League', Icon: FantasyDungeonLeagueIcon },
  { href: '/risk-japan', title: 'Risk', Icon: RiskIcon },
]
